import type { ReactNode } from 'react';
import { SafetyCertificateFilled } from '@ant-design/icons';
import { useI18n } from '@/i18n/useI18n';
import { useAssetUrl } from '@/theme/hubAssets';
import { useHubTheme } from '@/theme/ThemeContext';

/**
 * The room's lock-mark + product name — the ONE brand render site (header and gate screens).
 * P1: a themed hub's mark image and product name replace the built-in identity; an un-themed
 * hub renders exactly the DOM it always did (`sub` reproduces the header's welcome line inside
 * `.dr-header__titles`, where it has always lived).
 */
export function Brand({ showTitle = true, sub }: { showTitle?: boolean; sub?: ReactNode }) {
  const { t } = useI18n();
  const { theme } = useHubTheme();
  const markAssetId = theme?.brand?.markAssetId;
  const productName = theme?.brand?.productName;
  const markUrl = useAssetUrl(markAssetId);
  return (
    <span className="dr-header__brand">
      {markUrl ? (
        <span className="dr-header__mark dr-header__mark--image" aria-hidden="true">
          <img src={markUrl} alt="" />
        </span>
      ) : (
        <span className="dr-header__mark" aria-hidden="true">
          <SafetyCertificateFilled />
        </span>
      )}
      {showTitle && (
        <span className="dr-header__titles">
          <span className="dr-header__title">{productName ?? t('app.title')}</span>
          {sub && <span className="dr-header__sub">{sub}</span>}
        </span>
      )}
    </span>
  );
}
